
export const siteReceptionistPermissions = [
    {
        name: "Enrolment",
        route: "enrolment",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Personnel",
        route: "personnel",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    // {
    //     name: "Credentials",
    //     route: "enrolment-credentials",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    // {
    //     name: "Enrolment - Assigned Groups",
    //     route: "enrolment-groups",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    // {
    //     name: "Enrolment - Assigned Floors",
    //     route: "enrolment-floors",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    // {
    //     name: "Enrolment - Assigned Relationships",
    //     route: "enrolment-relationships",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    // {
    //     name: "Enrolment - Assigned Expiry Reasons",
    //     route: "enrolment-expiry-reasons",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    {
        name: "Reports",
        route: "reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transaction",
        route: "transaction-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "transaction-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "time-attendance-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Time & Attendance",
        route: "time-attendance-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Monitoring",
        route: "monitoring",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transactions",
        route: "transactions",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Dashboard",
        route: "dashboard",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Alarm Viewer",
        route: "alarms",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
]
